import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { intlShape, injectIntl } from 'react-intl';

import { Button } from '@salesforce/design-system-react';

import { SelectAgainRow } from '../';

import './SelectAgainEditor.scss';

class SelectAgainEditor extends Component {
  rows() {
    const rules = this.props.selectAgainRules || {};
    return Object.values(rules).map(rule => (
      <SelectAgainRow
        key={rule.asset_type}
        availableAssetTypes={this.props.availableAssetTypes}
        assetType={rule.asset_type}
        {...rule}
        onDeleteRule={() => this.props.onDeleteRule(rule)}
        onRuleChange={update =>
          this.props.onRuleChange(rule.asset_type, update)
        }
      />
    ));
  }
  render() {
    const { formatMessage } = this.props.intl;
    const addRule = formatMessage({
      id: 'components.ecs.rules.selection.addRule'
    });
    return (
      <div className="select-again-editor">
        <div className="select-again-rule-rows">{this.rows()}</div>
        {this.props.availableAssetTypes.length === 0 ? null : (
          <Button
            className="select-again-add-rule-button"
            label={addRule}
            iconCategory="utility"
            iconName="add"
            iconPosition="left"
            onClick={this.props.onAddRule}
          />
        )}
      </div>
    );
  }
}

SelectAgainEditor.propTypes = {
  selectAgainRules: PropTypes.array,
  availableAssetTypes: PropTypes.array,
  loadedFatigueRules: PropTypes.array,
  onAddRule: PropTypes.func.isRequired,
  onDeleteRule: PropTypes.func.isRequired,
  onRuleChange: PropTypes.func.isRequired,
  intl: intlShape.isRequired
};

export default injectIntl(SelectAgainEditor);
